var tooltips = {};

tooltips.init = function() {

  tooltips.bottomMargin = 25;
  tooltips.loadingPreviews = {};
  tooltips.loadedContent = {};
  tooltips.quoteReference = {};
  tooltips.knownPosts = {};
  tooltips.knownData = {};

  var posts = document.getElementsByClassName('postCell');

  for (var i = 0; i < posts.length; i++) {
    tooltips.addToKnownPostsForBackLinks(posts[i])
  }

  var threads = document.getElementsByClassName('opCell');

  for (i = 0; i < threads.length; i++) {
    tooltips.addToKnownPostsForBackLinks(threads[i])
  }

  tooltips.cacheExistingHTML('innerOP');
  tooltips.cacheExistingHTML('innerPost');

  var quotes = document.querySelectorAll('.quoteLink,.highlightlink');

  for (i = 0; i < quotes.length; i++) {
    tooltips.processQuote(quotes[i]);
  }

  if (settings.get('showYous')) {
    var userPosts = tooltips.getUserPosts();
    var cells = document.querySelectorAll('.postCell,.opCell');

    for (i = 0; i < cells.length; i++) {
      tooltips.markYouPost(cells[i], userPosts);
    }
  }

};

/* Set of the user's own post IDs, from localStorage.postingPasswords keys
   ("boardUri/threadId/postId"). The posting password is the board's only client-side
   identity signal (anon by design; no login except staff), so "your posts" == posts
   this browser has a stored password for. Returns {} if none / on parse error. */
tooltips.getUserPosts = function() {
  var set = {};

  try {
    var posts = Object.keys(JSON.parse(localStorage["postingPasswords"]));

    for (var i = 0; i < posts.length; i++) {
      var parts = posts[i].split('/');

      if (parts.length >= 3 && parts[2]) set[parts[2]] = true;
    }
  } catch(err) {}

  return set;
};

/* Numeric post ID referenced by a quote link (">>12345" -> "12345"), or null. */
tooltips.quotePostId = function(quote) {
  var m = (quote.text || '').match(/\d+/);

  return m ? m[0] : null;
};

/* Mark one post cell under showYous and report whether it replies to the user.
   Signals (CSS-driven, see _posting.scss):
     - .you-own on the cell when it is one of the user's own posts — a green dotted
       bar down the card's left edge + the person glyph by the ID sphere;
     - .you-replied on the cell when any quote link references one of the user's
       posts (a reply to you) — a red solid bar down the card's left edge, plus the
       inline "(You)" tag after that quote link.
   Returns true only for the replied-to-you case so callers can drive the tab title. */
tooltips.markYouPost = function(postCell, userPosts) {
  var replied = false;

  if (postCell.id && userPosts[postCell.id]) postCell.classList.add('you-own');

  /* Scope to this post's OWN message. The .opCell wraps the whole thread (all
     replies are nested inside it), so a bare querySelectorAll on the cell would scan
     every reply's quotes and over-mark. The first .divMessage in the subtree is this
     post's own body; backlinks ("who replied to me") live in .panelBacklinks, not here. */
  var message = postCell.querySelector('.divMessage');
  var quotes = message ? message.querySelectorAll('.quoteLink,.highlightlink') : [];

  for (var i = 0; i < quotes.length; i++) {
    var id = tooltips.quotePostId(quotes[i]);

    if (id && userPosts[id]) {
      replied = true;

      if (!quotes[i].nextSibling || !quotes[i].nextSibling.classList ||
          quotes[i].nextSibling.className !== 'post-you') {
        var span = document.createElement('span');
        span.className = 'post-you';
        span.textContent = ' ' + lang.postYou;
        quotes[i].parentNode.insertBefore(span, quotes[i].nextSibling);
      }
    }
  }

  if (replied) postCell.classList.add('you-replied');

  return replied;
};

tooltips.cacheExistingHTML = function(className) {

  var innerContent = document.getElementsByClassName(className);

  for (var i = 0; i < innerContent.length; i++) {

    var inner = innerContent[i];

    var temp = document.createElement('div');
    temp.className = 'innerPost';
    temp.innerHTML = inner.innerHTML;

    var deletionCheckBox = temp.getElementsByClassName('deletionCheckBox')[0];

    if (deletionCheckBox) {
      deletionCheckBox.remove();
    }

    var extraMenuButton = temp.getElementsByClassName('extraMenuButton')[0];

    if (extraMenuButton) {
      extraMenuButton.remove();
    }

    var quoteLink = temp.getElementsByClassName('linkSelf')[0];
    tooltips.loadedContent[quoteLink.href] = tooltips.fixQuoteAnchors(temp.outerHTML);
  }

};

// The engine renders the post header's number as <a class="linkQuote" href="#qN">,
// but no element with id "qN" exists — post cells use the plain numeric id (id="N").
// So tapping the number in a preview does nothing (the link just shows :visited).
// Rewrite those dead fragments to the real post id in PREVIEW copies only (live
// DOM untouched): same-thread taps then scroll to the post, cross-thread ones
// navigate. Applied where the cached preview strings are built.
tooltips.fixQuoteAnchors = function(html) {
  return html.replace(/href="([^"]*?)#q(\d+)"/g, 'href="$1#$2"');
};

tooltips.addToKnownPostsForBackLinks = function(posting) {

  var postBoard = posting.dataset.boarduri;

  var list = tooltips.knownPosts[postBoard] || {};
  tooltips.knownPosts[postBoard] = list;

  list[posting.id] = {
    added : [],
    container : posting.getElementsByClassName('panelBacklinks')[0]
  };

};

tooltips.addBackLink = function(quoteUrl, quote) {

  var matches;
  var board;
  var thread;
  var post;

  if (window.location.pathname == "/mod.js") {
    matches = quoteUrl.match(/\/mod\.js\?boardUri=(\w+)&threadId=(\d+)\#(\d+)/);
    if (!matches) {
      matches = quoteUrl.match(/\/(\w+)\/res\/(\d+)\.html\#(\d+)/);
    }
    board = matches[1];
    thread = matches[2];
    post = matches[3];
  } else if (/^\/\w+\/last\//.test(window.location.pathname)){
    matches = quoteUrl.match(/\/(\w+)\/last\/(\d+)\.html\#(\d+)/);
    if (!matches) {
      matches = quoteUrl.match(/\/(\w+)\/res\/(\d+)\.html\#(\d+)/);
    }
    board = matches[1];
    thread = matches[2];
    post = matches[3];
  } else {
    matches = quoteUrl.match(/\/(\w+)\/res\/(\d+)\.html\#(\d+)/);
    board = matches[1];
    thread = matches[2];
    post = matches[3];
  }

  var knownBoard = tooltips.knownPosts[board];

  if (knownBoard) {

    var knownBackLink = knownBoard[post];

    if (knownBackLink) {

      var containerPost = quote.parentNode.parentNode;

      while (!containerPost.classList.contains('postCell')
          && !containerPost.classList.contains('opCell')) {
        containerPost = containerPost.parentNode;
      }

      var sourceBoard = containerPost.dataset.boarduri;
      var sourcePost = containerPost.id;

      var sourceId = sourceBoard + '_' + sourcePost;

      if (knownBackLink.added.indexOf(sourceId) > -1) {
        return;
      } else {
        knownBackLink.added.push(sourceId);
      }

      var innerHTML = '>>';

      if (sourceBoard != board) {
        innerHTML += '/' + containerPost.dataset.boarduri + '/';
      }

      innerHTML += sourcePost;

      var backLink = document.createElement('a');
      backLink.innerHTML = innerHTML;

      var backLinkUrl;

      if (window.location.pathname == "/mod.js") {
        backLinkUrl = '/mod.js?boardUri=' + sourceBoard + '&threadId=' + thread + '#' + sourcePost;
      } else if (/^\/\w+\/last\//.test(window.location.pathname)){
        backLinkUrl = '/' + sourceBoard + '/last/' + thread + '.html#' + sourcePost;
      } else {
        backLinkUrl = '/' + sourceBoard + '/res/' + thread + '.html#' + sourcePost;
      }

      backLink.href = backLinkUrl;

      knownBackLink.container.appendChild(backLink);

      tooltips.processQuote(backLink, true, quoteUrl);

    }

  }

};

// --- Mobile (<=600px) tap-to-preview panel ---------------------------------
// One shared fixed panel at the top of the viewport, full width, internally
// scrollable. Replaces the hover tooltip on touch where mouseenter/mouseout
// are synthesized by taps and race each other (2026-08-17 operator report:
// flash loop / wrong position / highlight-only).
tooltips.mobilePanel = null;
tooltips.mobileQuote = null;

tooltips.showMobile = function(quote, quoteUrl) {

  if (!tooltips.mobilePanel) {
    tooltips.mobilePanel = document.createElement('div');
    tooltips.mobilePanel.className = 'quoteTooltip mobileQuotePanel';
    document.body.appendChild(tooltips.mobilePanel);

    // Dismiss on a touch OUTSIDE the panel (plain content taps inside keep it
    // open for scrolling/reading). Compare against tooltips.mobileQuote at
    // event time — the panel is shared and its quote changes when the user taps
    // a different backlink (a closure over `quote` here would go stale after
    // the first switch).
    document.addEventListener('touchstart', function(e) {
      if (!tooltips.mobilePanel) return;   // closed — nothing to do
      if (!tooltips.mobilePanel.contains(e.target)
          && tooltips.mobileQuote !== e.target) {
        tooltips.closeMobile();
      }
    }, { passive: true });

    // Dismiss on a LINK tapped INSIDE the panel (e.g. the post number), but do
    // it from CLICK, not touchstart: removing the panel during touchstart yanks
    // the link out of the DOM before the browser synthesizes the click, so the
    // jump never fired. On click, dispatch finishes first and the default
    // action (fragment scroll / navigation) runs after our handler — so the
    // order is: jump lands, THEN the panel goes away.
    document.addEventListener('click', function(e) {
      if (!tooltips.mobilePanel) return;
      if (tooltips.mobilePanel.contains(e.target)
          && e.target.closest && e.target.closest('a[href]')) {
        tooltips.closeMobile();
      }
    });
  }

  tooltips.mobileQuote = quote;
  var panel = tooltips.mobilePanel;

  // Reset — the panel is shared, so tooltipFix must not accumulate across opens.
  panel.className = 'quoteTooltip mobileQuotePanel';

  if (tooltips.loadedContent[quoteUrl]) {
    quote.style.cursor = '';
    panel.innerHTML = tooltips.loadedContent[quoteUrl];

    if (panel.getElementsByClassName('opHead').length > 0) {
      panel.className += ' tooltipFix';
    }

  } else {
    quote.style.cursor = 'wait';
    panel.innerHTML = 'Loading';
  }

  if (!tooltips.loadedContent[quoteUrl]
      && !tooltips.loadingPreviews[quoteUrl]) {
    tooltips.loadQuote(panel, quoteUrl, quote);
  }

};

tooltips.closeMobile = function() {

  if (tooltips.mobilePanel) {
    tooltips.mobilePanel.remove();
    tooltips.mobilePanel = null;
  }

  tooltips.mobileQuote = null;

};

// --- end mobile panel --------------------------------------------------------

tooltips.checkHeight = function(tooltip) {

  // The mobile panel is position:fixed — document-space clamping would push it
  // off-screen (negative top once the page is scrolled). CSS max-height +
  // overflow handle its bounds instead.
  if (tooltip.classList.contains('mobileQuotePanel')) {
    return;
  }

  var windowHeight = document.documentElement.clientHeight + window.scrollY;

  if (tooltip.offsetHeight + tooltip.offsetTop + tooltips.bottomMargin > windowHeight) {
    tooltip.style.top = (windowHeight - tooltip.offsetHeight - tooltips.bottomMargin)
        + 'px';
  }

}

tooltips.markQuotes = function (tooltip, backLinkQuoteUrl) {

  var previewTooltips = tooltip.getElementsByClassName('quoteLink');

  if (previewTooltips.length > 1) {

    for (var i = 0; i < previewTooltips.length; i++) {

      if (previewTooltips[i].href === backLinkQuoteUrl) {
        previewTooltips[i].style = 'text-decoration-style: dashed;';
      }

    }
  }

}

tooltips.processQuote = function(quote, backLink, backLinkQuoteUrl) {

  var tooltip;

  var quoteUrl = quote.href;

  if (!backLink) {
    tooltips.addBackLink(quoteUrl, quote);
  }

  if (window.innerWidth <= 600) {
    // Mobile: hover does not exist on touch — a tap synthesizes mouseenter, and
    // placing the preview over the tapped link made the browser's re-hit-test
    // fire mouseout/mouseenter in an oscillation loop (flash). Instead:
    //   tap 1 on a link  -> shared preview panel at top of viewport (no jump)
    //   tap same link    -> closes AND follows it (jump to the post)
    //   tap any other    -> closes (or switches the preview, if another link)
    quote.onclick = function(e) {
      if (window.innerWidth > 600) return;   // resized wide: desktop behavior
      if (tooltips.mobilePanel && tooltips.mobileQuote === quote) {
        tooltips.closeMobile();              // no preventDefault: follow the link
      } else {
        e.preventDefault();                  // read in place, don't navigate yet
        tooltips.showMobile(quote, quoteUrl);
      }
    };
    return;
  }

  quote.onmouseenter = function(e) {

    // Narrow viewport: the tap-to-preview panel owns previews here (see the
    // branch in processQuote). This handler can still fire on a page loaded
    // wide and resized narrow — never create the positioned tooltip, or its
    // placement over the tapped link re-triggers the touch hit-test
    // oscillation loop. Checked first so no empty div is left behind.
    if (window.innerWidth <= 600) {
      return;
    }

    tooltip = document.createElement('div');
    tooltip.className = 'quoteTooltip boardThreadList';

    document.body.appendChild(tooltip);

    var rect = quote.getBoundingClientRect();

    tooltip.style.display = 'inline';

    /* begin stealing from 8chan.se */

    if (rect.left > window.innerWidth/2) {
      var right = window.innerWidth - rect.left - window.scrollX;
      tooltip.style.right = right + 'px';
    } else {
      var left = rect.right + 10 + window.scrollX;
      tooltip.style.left = left + 'px';
    }
    tooltip.style.top = (rect.top + window.scrollY) + 'px';

    /* end stealing from 8chan.se */

    if (tooltips.loadedContent[quoteUrl]) {
      quote.style.cursor = '';
      tooltip.innerHTML = tooltips.loadedContent[quoteUrl];

      var isOP = tooltip.getElementsByClassName('opHead').length > 0;

      if (isOP) {
        tooltip.className += 'tooltipFix';
      }


      if (backLinkQuoteUrl) {
        tooltips.markQuotes(tooltip, backLinkQuoteUrl);
      }

      tooltips.checkHeight(tooltip);

    } else {
      quote.style.cursor = 'wait';
    }

    if (!tooltips.loadedContent[quoteUrl]
        && !tooltips.loadingPreviews[quoteUrl]) {
      tooltips.loadQuote(tooltip, quoteUrl, quote);
    }

    if (!api.isBoard) {
      var matches = quote.href.match(/\#(\d+)/);

      quote.onclick = function() {
        thread.markPost(matches[1]);
      };
    }

  };

  quote.onmouseout = function() {
    if (tooltip) {
      tooltip.remove();
      tooltip = null;
    }
  };

};

tooltips.generateHTMLFromData = function(postingData, tooltip, quoteUrl, quote) {

  if (!postingData) {
    quote.style.cursor = 'not-allowed';
    return;
  }

  var tempDiv = posting.addPost(postingData, postingData.boardUri,
      postingData.threadId, true).getElementsByClassName('innerPost')[0];

  tempDiv.getElementsByClassName('deletionCheckBox')[0].remove();

  tempDiv.getElementsByClassName('extraMenuButton')[0].remove();

  quote.style.cursor = '';

  var fixedHtml = tooltips.fixQuoteAnchors(tempDiv.outerHTML);
  tooltip.innerHTML = fixedHtml;

  tooltips.checkHeight(tooltip);

  tooltips.loadedContent[quoteUrl] = fixedHtml;

};

tooltips.cacheData = function(threadData) {

  for (var i = 0; i < threadData.posts.length; i++) {
    var postData = threadData.posts[i];
    tooltips.knownData[threadData.boardUri + '/' + postData.postId] = postData;
  }

  tooltips.knownData[threadData.boardUri + '/' + threadData.threadId] = threadData;

};

tooltips.loadQuote = function(tooltip, quoteUrl, quote) {

  var board;
  var thread;
  var post;

  if (window.location.pathname == "/mod.js") {
    matches = quoteUrl.match(/\/mod\.js\?boardUri=(\w+)&threadId=(\d+)\#(\d+)/);
    if (!matches) {
      matches = quoteUrl.match(/\/(\w+)\/res\/(\d+)\.html\#(\d+)/);
    }
    board = matches[1];
    thread = +matches[2];
    post = +matches[3];
  } else if (/^\/\w+\/last\//.test(window.location.pathname)){
    matches = quoteUrl.match(/\/(\w+)\/last\/(\d+)\.html\#(\d+)/);
    if (!matches) {
      matches = quoteUrl.match(/\/(\w+)\/res\/(\d+)\.html\#(\d+)/);
    }
    board = matches[1];
    thread = +matches[2];
    post = +matches[3];
  } else {
    matches = quoteUrl.match(/\/(\w+)\/res\/(\d+)\.html\#(\d+)/);
    board = matches[1];
    thread = +matches[2];
    post = +matches[3];
  }

  var postingData = tooltips.knownData[board + '/' + post];

  if (postingData) {
    tooltips.generateHTMLFromData(postingData, tooltip, quoteUrl, quote);
    return;
  }

  var threadUrl = '/' + board + '/res/' + thread + '.json';

  tooltips.loadingPreviews[quoteUrl] = true;

  api.localRequest(threadUrl, function receivedData(error, data) {

    delete tooltips.loadingPreviews[quoteUrl];

    if (error) {
      quote.style.cursor = 'not-allowed';
      return;
    }

    tooltips.cacheData(JSON.parse(data));

    tooltips.generateHTMLFromData(tooltips.knownData[board + '/' + post], tooltip, quoteUrl, quote);

  });

};

tooltips.init();
